// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
import {z} from 'zod';

export const FilterFormSchema = z.object({
    status: z.string().optional(),
});
